import type {EvaluatorCfg} from '../../config'
import {CoherenceEvaluator} from './coherence'
import {FluencyEvaluator} from './fluency'
import {SimilarityEvaluator} from './similarity'

export const BuiltIn: Record<string, EvaluatorCfg> = {
  coherence: CoherenceEvaluator,
  fluency: FluencyEvaluator,
  similarity: SimilarityEvaluator,
}
